(function() {
  'use strict';

  angular.module('ringbaPortal').component('jsTagCodeSnippet', {
    bindings: {
      jsTag: '<',
      campaignId: '<',
    },
    controller: JsTagCodeSnippetController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/js-tag-code-snippet/js-tag-code-snippet.view.html'
  });

  function JsTagCodeSnippetController(

  ) {
    'ngInject';
  }
})();
